import MuiStepLabel, { StepLabelProps } from '@mui/material/StepLabel';

const EDStepLabel = (props: StepLabelProps) => {
  return <MuiStepLabel {...props} />;
};

export default EDStepLabel;
